import { SelectOption } from "@rio-cloud/rio-uikit";
import { getAccounts, getAssets, getBranch, getCategories, getDrivers, getSegments, getSubCategories, getSuppliers } from "../../../services";
import { useEffect, useState } from "react";
import { FormState } from "./form";

const initialDefaultForm = {
  date: "",
  value: "",
  branch: "",
  segment: "",
  supplier: "",
  trip: "",
  vehicle: "",
  driver: [],
  category: "",
  subcategory: "",
  observation: "",
  taxes: "",
};

export const useFormReceipt = () => {
  const [branchs, setBranchs] = useState<SelectOption[]>([]);
  const [segments, setSegments] = useState<SelectOption[]>([]);
  const [supplier, setSupplier] = useState<SelectOption[]>([]);
  const [drivers, setDrivers] = useState<SelectOption[]>([]);
  const [categories, setCategories] = useState<SelectOption[]>([]);
  const [subCategories, setSubCategories] = useState<SelectOption[]>([]);
  const [vehicles, setVehicles] = useState<SelectOption[]>([]);

  const [form, setForm] = useState<FormState>(initialDefaultForm);

  const mountOption = (data: any[]) => {
    return data?.map((res: { id: number; name: string }) => {
      return {
        id: res.id.toString(),
        label: res.name,
      };
    });
  };

  const fetchBranchs = async () => {
    try {
      const response = await getBranch();
      setBranchs(mountOption(response));
    } catch (error) {
      setBranchs([]);
    }
  };

  const fetchSegments = async () => {
    try {
      const response = await getSegments();
      setSegments(mountOption(response));
    } catch (error) {
      setSegments([]);
    }
  };

  const fetchSupplier = async () => {
    try {
      const response = await getSuppliers('CLIENTE');
      setSupplier(mountOption(response.data));
    } catch (error) {
      setSupplier([]);
    }
  };

  const getDriverName = (driver: Record<string, unknown>): string => {
    const firstName = driver.first_name ?? driver.firstName ?? driver.name ?? "";
    const lastName = driver.last_name ?? driver.lastName ?? driver.surname ?? "";
    const combined = `${firstName ?? ""} ${lastName ?? ""}`.trim();
    if (combined) return combined;
    return (driver.full_name as string) ?? (driver.displayName as string) ?? (driver.nickname as string) ?? "Motorista";
  };

  const fetchDrivers = async () => {
    try {
      const response = await getDrivers();
      setDrivers(response.map((driver: Record<string, unknown>) => ({
        id: String(driver.id),
        label: getDriverName(driver),
      })));
    } catch (error) {
      setDrivers([]);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await getCategories();
      const filtered = response.filter((res: { type: "RECEITA" | "DESPESA" }) => res.type === "RECEITA");

      setCategories(mountOption(filtered));
    } catch (error) {
      setCategories([]);
    }
  };

  const fetchSubCategories = async () => {
    try {
      const response = await getSubCategories(form.category);
      setSubCategories(mountOption(response.data));
    } catch (error) {
      setSubCategories([]);
    }
  };

  const fetchVehicles = async () => {
    try {
      const response = await getAssets();
      setVehicles(mountOption(response.data));
    } catch (error) {
      setSubCategories([]);
    }
  };

  useEffect(() => {
    // fetchBranchs();
    // fetchSegments();
    // fetchSupplier();
    // fetchDrivers();
    // fetchCategories();
    // fetchVehicles();
  }, []);

  useEffect(() => {
    if (form?.category) {
      fetchSubCategories();
    }
  }, [form?.category]);

  return {
    branchs,
    segments,
    supplier,
    drivers,
    categories,
    subCategories,
    vehicles,
    fetchVehicles,
    fetchSubCategories,
    fetchBranchs,
    fetchSegments,
    fetchSupplier,
    fetchDrivers,
    fetchCategories,
    form,
    setForm,
    initialDefaultForm,
  };
};
